import { connect } from 'react-redux';

import DataFlowOverviewTab from './DataFlowOverviewTab';
import { fetchPipelineDoc, updatePipelineDoc } from '../../../actions';
import { isFlowNodeResource } from 'js/lib/ResourceUtils';

const mapStateToProps = (state, ownProps) => {
  const {
    request,
    entities: { docs },
    pipelines: { docById },
  } = state;

  const { data } = ownProps;
  const flowNodeId = DataFlowOverviewTab.resolveFlowNodeId(data);

  return {
    isLoading: {
      doc: request.GET_PIPELINE_DOC_REQUEST || false,
    },
    doc:
      data && flowNodeId && docById[flowNodeId] && docs[docById[flowNodeId]]
        ? docs[docById[flowNodeId]].text
        : null,
  };
};

export default connect(mapStateToProps, {
  fetchPipelineDoc,
  updatePipelineDoc,
})(DataFlowOverviewTab);
